import styled from '@emotion/styled'
import { TreeItemProps, TreeItem, treeItemClasses } from '@mui/lab'
import { Box, Checkbox } from '@mui/material'
import React from 'react'
interface Props extends Omit<TreeItemProps, 'onClick'> {
  checked: boolean
  customOnChange: (id: string, newValue: boolean) => void
  indeterminate?: boolean
  haveChildren?: boolean
  onClick?: () => void
}

const CustomTreeItem: ReactFC<Props> = ({
  checked: propsChecked,
  children,
  customOnChange,
  indeterminate,
  haveChildren,
  onClick,
  ...props
}) => {
  const StyledTreeItem = styled((props: TreeItemProps) => {
    const handleOnCheckboxChange = (
      _e: React.ChangeEvent<HTMLInputElement>,
      newCheckedValue: any
    ) => {
      customOnChange(props.nodeId, newCheckedValue)
    }

    const handleOnClickLabel: React.MouseEventHandler<HTMLLIElement> = (e) => {
      e.preventDefault()
      e.stopPropagation()
      onClick?.()
      if (haveChildren) return
      customOnChange(props.nodeId, !propsChecked)
    }

    return (
      <Box display='flex' alignItems='flex-start'>
        <Checkbox
          checked={propsChecked}
          size='small'
          sx={{
            margin: '2px 0 0 0',
            padding: 0
          }}
          onChange={handleOnCheckboxChange}
          indeterminate={propsChecked ? false : indeterminate!}
        />
        <TreeItem onClick={handleOnClickLabel} {...props} />
      </Box>
    )
  })({
    [`& .${treeItemClasses.focused}`]: {
      background: 'none'
    },
    [`& .${treeItemClasses.selected}`]: {
      background: 'none !important'
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      '& .close': {
        opacity: 0.3
      }
    },
    [`& .${treeItemClasses.group}`]: {
      marginLeft: 15,
      paddingLeft: 18,
      borderLeft: '1px solid gray'
    },
    [`& .${treeItemClasses.label}`]: {
      whiteSpace: 'nowrap'
    }
  })

  return <StyledTreeItem {...props}>{children}</StyledTreeItem>
}
export default CustomTreeItem
